import { defineComponent } from 'vue'

import { CsCopyTextLink } from '@sunrise/components'
import { useGlobalStore } from '@sunrise/shared'

export default defineComponent({
    name: 'MsSafetyInstructions',
    components: {
        CsCopyTextLink,
    },
    setup() {
        const requestContext = useGlobalStore().requestContext
        const safetyInstructionsUrl = `${requestContext?.url.origin}/deutschland/immobilien/magazin/sicherheit/schutz-vor-immobilienbetrug`

        return {
            safetyInstructionsUrl,
        }
    },
})
